/*
 * healthmart
 * version 2.2
 * http://www.healthmart.com
 *
 * Copyright (c) 2019 healthmart ltd
 * Author healthmart ltd <support@healthmart.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-custom-icon',
    templateUrl: './custom-icon.component.html',
    styleUrls: ['./custom-icon.component.scss'],
    standalone: false
})
export class CustomIconComponent implements OnInit {

    @Input() icon: string;

    constructor() { }

    ngOnInit(): void {

    }
}